import persistState from "redux-localstorage";
import * as contentful from "contentful-management";
import createLogger from 'redux-logger';

import {
	applyMiddleware,
	createStore,
	combineReducers,
	compose
} from "redux";

// --------------------------------------------------

const token = (state = "", action) => {
	const o = {
		"SET_TOKEN": () => action.token,
		"CLEAR_TOKEN": () => "",
		noop: () => state,
	};
	return (o[action.type] || o.noop)();
};

const space = (state = null, action) => {
	const o = {
		"SET_SPACE": () => action.space,
		"CLEAR_SPACE": () => null,
		"CLEAR_TOKEN": () => null,
		"RESTORE_SPACE": () => state,
		noop: () => state,
	};
	return (o[action.type] || o.noop)();
};

const loadingOverlay = (state = "", action) => {
	const o = {
		"START_LOADING": () => action.message || "Loading...",
		"STOP_LOADING": () => "",
		noop: () => state,
	};
	return (o[action.type] || o.noop)();
};

const panelOpen = (state = false, action) => {
	const o = {
		"OPEN_PANEL": () => true,
		"CLOSE_PANEL": () => false,
		"TOGGLE_PANEL": () => !state,
		noop: () => state,
	};
	return (o[action.type] || o.noop)();
}

const reducer = combineReducers({
	token,
	space,
	loadingOverlay,
	panelOpen
});

// --------------------------------------------------

const restoreSpace = store => next => action => {
	const storeState = store.getState();
	if(
		action.type === "RESTORE_SPACE"
		&& storeState.space
		&& !storeState.space.update
	) {
		const client = contentful.createClient({
			accessToken: storeState.token,
		});
		client.getSpace(storeState.space.sys.id)
		.then(space => store.dispatch({
			type: "SET_SPACE",
			space,
		}))
		.catch(space => {
			console.log("issue with teh space:", space);
			store.dispatch({
				type: "CLEAR_SPACE",
			})
		});
	}	

	next(action);
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const enhancer = composeEnhancers(
	applyMiddleware(
		restoreSpace,
		createLogger()
	),
	persistState()
);

// --------------------------------------------------

export default createStore(reducer, enhancer);


// WEBPACK FOOTER //
// ./src/store.js